export const shouldPartitionAllView = ({
  label,
  conversationType,
  hasAppliedFiltersOrActiveFolders,
  assigneeType,
  allAssigneeType,
  searchQuery,
}) =>
  !label &&
  !conversationType &&
  !hasAppliedFiltersOrActiveFolders &&
  assigneeType === allAssigneeType &&
  !searchQuery;

export const canFetchPartitionSections = ({
  isPartitionedAllView,
  companyReady,
  topicReady,
}) => isPartitionedAllView && companyReady && topicReady;

export const dispatchPartitionSection = ({
  dispatch,
  ready,
  filterKey,
  conversationFilters,
  labels,
  page,
  cursor,
  replyState,
  sectionOptions = {},
}) => {
  if (!ready) return null;

  return dispatch('fetchConversationSection', {
    filterKey,
    ...sectionOptions,
    filters: {
      ...conversationFilters,
      labels,
      page,
      cursor,
      replyState,
    },
  });
};

export const conversationsForReplySection = (conversations, replyState) => {
  const isUnrepliedSection = replyState === 'unreplied';
  return conversations.filter(
    conversation => Boolean(conversation.mh_unreplied) === isUnrepliedSection
  );
};
